export const BASE_URL = "https://api.bill-lex.com";

export const API_ENDPOINTS = {
  registration: `${BASE_URL}/user/registration`,
  getSalt: `${BASE_URL}/user/salt`,
  login: `${BASE_URL}/user/login`,
  DASHBOARD: `/dashboard`,
  DASHBOARD_ANALYTICS: `/dashboard/analytics`,
  currentUser: `${BASE_URL}/user/current-user`,
  LOGOUT: `/user/logout`,
  USER: {
    GET_USER: `${BASE_URL}/user`,
    UPDATE_USER: `${BASE_URL}/user/update`,
    GET_USER_PRINT_DETAILS: `${BASE_URL}/user/userInfoToPrint`,
  },
  INVENTORY: {
    GET_DATA: `/inventory`,
    SAVE_DATA: `/inventory/save`,
    EDIT_DATA: `/inventory/edit`,
    SAVE_ADDON_DATA: `/inventory/add-on/save`,
    UPDATE_ADDON_DATA: `/inventory/add-on/update`,
    SAVE_CATEGORY_DATA: `/inventory/category/save`,
  },
  BILLING: {
    SAVE_BILL: `${BASE_URL}/billing/save`,
  },
  ORDERS: {
    GET_ORDERS: `${BASE_URL}/orders`,
  },
  CASHFREE: {
    CREATE_SESSION: `${BASE_URL}/cashfree/create-session`,
    CREATE_NEW_SESSION: `${BASE_URL}/cashfree/create-new-session`,
    CREATE_LINK: `${BASE_URL}/cashfree/sendPaymentLink/1.0.1`,
  },
  CUSTOMERS: {
    GET: `${BASE_URL}/customers`,
  },
};
